<template>
	<div class="alarm-notify">
		<div class="view-title">
			<translate>Alarm Notify</translate>
		</div>
		<div class="alarm-notify-container">
			<!--search input-->
			<div class="add-ssk">
				<div class="pull-right">
					<el-form :inline="true" class="demo-form-inline">
						<el-checkbox v-model="search.is_read" @change="onSelectIsRead" />
						<translate style="margin-right: 5px">Unread</translate>

						<el-select v-model="search.role" :placeholder="attrText.select" @change="onSelectRole" class="account-search">
							<el-option v-for="(item, index) in selectOptions" :label="item.text | translate($gettext)" :value="item.val" :key="index"></el-option>
						</el-select>
						<el-input icon="search" v-model="search.account" :placeholder="attrText.input" class="searchInput" :disabled="search.isDisabled"></el-input>
						<el-date-picker v-model="search.startTime" type="date" :placeholder="attrText.startTime" align="right" class="date-picker"></el-date-picker>
						<el-date-picker v-model="search.endTime" type="date" :placeholder="attrText.endTime" align="right" class="date-picker"></el-date-picker>
						<el-button class="btn-class" @click="onSearch">
							<translate>Search</translate>
						</el-button>
						<el-button class="btn-class" type="primary" @click="exportLog">
							<translate>Export</translate>
						</el-button>
					</el-form>
				</div>
			</div>

			<el-table v-loading="loading" :data="log.list" style="width: 100%" stripe>
				<el-table-column :label="attrText.operationTime" prop="operation_time" width="200"> </el-table-column>
				<el-table-column :label="attrText.users" prop="account_name" width="80"> </el-table-column>
				<el-table-column :label="attrText.sourceIp" prop="con_ip"> </el-table-column>
				<el-table-column :label="attrText.operationObj" prop="resource_name"> </el-table-column>
				<el-table-column :label="attrText.workGroup" prop="project_name"> </el-table-column>
				<el-table-column :label="attrText.connectType" prop="way"> </el-table-column>
				<el-table-column :label="attrText.eventDesc">
					<template scope="scope">
						<el-tooltip effect="light" placement="top" popper-class="alarm-trigger-tooltip" :open-delay="200">
							<div slot="content" class="alarm-trigger-tooltip-content">{{ scope.row.command || '-' }}</div>
							<p class="ellipsis-mult">{{ scope.row.command || '-' }}</p>
						</el-tooltip>
					</template>
				</el-table-column>
				<el-table-column :label="attrText.triggerStrategy">
					<template scope="scope">
						<el-tooltip effect="light" placement="top" popper-class="alarm-trigger-tooltip" :open-delay="200">
							<div slot="content" class="alarm-trigger-tooltip-content">{{ scope.row.match_command || '-' }}</div>
							<p class="trigger-strategy-text">{{ scope.row.match_command || '-' }}</p>
						</el-tooltip>
					</template>
				</el-table-column>
				<el-table-column :label="attrText.norifyObj">
					<template scope="scope">
						<div v-if="scope.row.notice_accounts">
							<p v-for="i in JSON.parse(scope.row.notice_accounts)" :key="i">{{ i }}</p>
						</div>
					</template>
				</el-table-column>
				<el-table-column :label="attrText.status">
					<template scope="scope">
						<span v-if="scope.row.is_read">
							<translate>Read</translate>
						</span>
						<span v-else style="color: #fda541">
							<translate>Unread</translate>
						</span>
					</template>
				</el-table-column>

				<el-table-column :label="attrText.action">
					<template scope="scope">
						<el-button type="text" @click="toShowAlarmDetail(scope.row)">查看</el-button>
					</template>
				</el-table-column>
			</el-table>

			<!--pagination-->
			<div class="pagination">
				<el-pagination layout="prev, pager, next" :total="log.totalPage" :current-page.sync="log.currentPage" :page-size="10" @current-change="onChangePage" v-if="log.totalPage > 10"></el-pagination>
			</div>
		</div>

		<component :is="currentRightPanel" :items="rightPanelData" @onClosePanel="onClosePanel" @callback="getAlarmLog"> </component>
	</div>
</template>

<script>
import STORE_CONST from '../../store/consts'
import { SelectOptionsConfig } from '../../config'
import alarmLogDetail from './model/alarm-log-detail.vue'
import { Utils, baseUrl } from '../../config'

export default {
	data() {
		return {
			selectOptions: SelectOptionsConfig.alarmLogs.role,
			loading: true,
			log: {
				list: [],
				totalPage: 0,
				currentPage: 1,
			},
			search: {
				options: [],
				isAdmin: '',
				account: '',
				startTime: '',
				endTime: '',
				eventType: '',
				role: '',
				is_read: true,
				isDisabled: true,
			},
			eventShow: false,
			currentRightPanel: null,
			rightPanelData: null,
			teamList: [],
		}
	},
	computed: {
		// attribute text
		attrText() {
			return this.getAttrText()
		},
	},
	created() {
		this.search.options.push({
			key: 'is_read',
			val: this.search.is_read ? 0 : 1,
		})
		if (this.$route.query.notice_accounts) {
			for (let k in this.$route.query) {
				this.search.options.push({
					key: k,
					val: this.$route.query[k],
				})
				this.search.role = k
				this.search.account = this.$route.query[k]
			}
		}
		this.getAlarmLog(1)
		this.getTeamList()
	},
	methods: {
		// init attribute text
		getAttrText() {
			return {
				event: this.$gettext('Event'),
				safeAdmin: this.$gettext('Safe Admin'),
				optAdmin: this.$gettext('Opt Admin'),
				auditAdmin: this.$gettext('Audit Admin'),
				admin: this.$gettext('Administrator'),
				select: this.$gettext('Select'),
				startTime: this.$gettext('Start Time'),
				endTime: this.$gettext('End Time'),
				input: this.$gettext('Please input'),
				time: this.$gettext('Time'),
				account: this.$gettext('Account'),
				eventType: this.$gettext('Event Type'),
				action: this.$gettext('Action'),
				operationTime: this.$gettext('Operation Time'),
				sourceIp: this.$gettext('Source IP'),
				operationObj: this.$gettext('Operation Obj'),
				workGroup: this.$gettext('In Work Group'),
				connectType: this.$gettext('Connect Type'),
				eventDesc: this.$gettext('Event Desc'),
				norifyObj: this.$gettext('Notify Obj'),
				users: this.$gettext('Users'),
				triggerStrategy: this.$gettext('Trigger Strategy'),
				status: this.$gettext('Status'),
			}
		},

		// 获取告警日志
		getAlarmLog(page) {
			this.loading = true
			let params = {
				page_index: page || 1,
			}
			this.search.options.forEach((item) => {
				params[item.key] = item.val
			})

			this.$store.dispatch(STORE_CONST.LOG.ALARM, { params: params }).then(
				(res) => {
					console.log(res, '告警日志')
					if (res.objects && res.objects.length) {
						this.log.list = this.$store.getters.logs.alarmLogs.objects
						this.log.totalPage = this.$store.getters.logs.alarmLogs.num_results
						this.$store.commit(STORE_CONST.LOG.UNREAD_COUNTS, 0)
						setTimeout(() => {
							this.eventShow = true
						}, 10)
					} else {
						this.log.list = res.objects
						this.log.totalPage = res.num_results
					}
					this.loading = false
					console.log(SelectOptionsConfig.alarmLogs, 'SelectOptionsConfig.alarmLogs')
				},
				() => {
					this.loading = false
				},
			)
		},

		onSelectIsRead() {
			this.log.currentPage = 1
			this.search.options = this.search.options.filter((item) => item.key !== 'is_read')
			this.search.options.push({
				key: 'is_read',
				val: this.search.is_read ? 0 : 1,
			})
			this.getAlarmLog(1)
		},
		// 查看告警详情
		toShowAlarmDetail(row) {
			const time = !this.currentRightPanel || this.currentRightPanel.name === 'alarmLogDetail' ? 0 : 300
			this.currentRightPanel = alarmLogDetail
			this.$nextTick(() => {
				setTimeout(() => {
					this.rightPanelData = row
				}, time)
			})
		},
		// 获取团队成员
		getTeamList() {
			this.$store.dispatch(STORE_CONST.TEAM.GET_MEMBER_LIST).then((res) => {
				console.log(res, 'res')
				if (res && res.objects && res.objects.length) {
					this.teamList = res.objects
				}
			})
		},

		// search event
		onSearch() {
			this.log.currentPage = 1
			this.search.options = []
			if (this.search.startTime !== '') {
				this.search.options.push({
					key: 'start_time',
					val: this.search.startTime.getTime() / 1000,
				})
			}
			if (this.search.endTime !== '') {
				this.search.options.push({
					key: 'end_time',
					val: this.search.endTime.getTime() / 1000 + 24 * 3600,
				})
			}
			if (this.search.isAdmin !== '') {
				this.search.options.push({
					key: 'admin',
					val: this.search.isAdmin,
				})
			}
			if (this.search.account !== '') {
				if (this.search.role === '') {
					this.search.options.push({
						key: 'account',
						val: this.search.account,
					})
				} else {
					this.search.options.push({
						key: this.search.role,
						val: this.search.account,
					})
				}
			}
			if (this.search.eventType !== '') {
				this.search.options.push({
					key: 'event',
					val: this.search.eventType,
				})
			}
			this.getAlarmLog(1)
		},
		// change page event
		onChangePage(page) {
			this.getAlarmLog(page)
		},
		// watch search role's value
		onSelectRole() {
			if (this.search.role !== '') {
				this.search.isDisabled = false
			}
		},

		// reset search params
		resetSearchValue() {
			this.search = Object.assign({}, this.search, {
				isAdmin: '',
				account: '',
				startTime: '',
				endTime: '',
				eventType: '',
				role: '',
				isDisabled: true,
			})
		},
		// 关闭侧滑回调
		onClosePanel() {
			this.currentRightPanel = null
			this.rightPanelData = null
		},

		// 导出日志
		exportLog() {
			if (this.search.role === '') {
				window.open(`${baseUrl.apiUrl}/event/sys_log_export?log_type=alarmLogs&admin=${this.search.isAdmin}&start_time=${this.search.startTime ? this.search.startTime.getTime() / 1000 : ''}&end_time=${this.search.endTime ? this.search.endTime.getTime() / 1000 + 24 * 3600 : ''}&event=${this.search.eventType}&account=${this.search.account}`, '_blank')
			} else {
				window.open(`${baseUrl.apiUrl}/event/sys_log_export?log_type=alarmLogs&admin=${this.search.isAdmin}&start_time=${this.search.startTime ? this.search.startTime.getTime() / 1000 : ''}&end_time=${this.search.endTime ? this.search.endTime.getTime() / 1000 + 24 * 3600 : ''}&event=${this.search.eventType}&${this.search.role}=${this.search.account}`, '_blank')
			}
		},
	},

	components: {
		alarmLogDetail,
	},
}
</script>

<style lang="scss" rel="stylesheet/scss">
@import '../../assets/css/variable';

.alarm-notify {
	.el-table__body-wrapper {
		overflow: hidden;
	}

	.alarm-notify-container {
		padding: 15px;
	}

	.add-ssk {
		padding: 0 15px;
		height: 60px;
		line-height: 60px;
		background-color: #fff;
		border: 1px solid $border-color;
		border-bottom: none;

		.pull-right {
			.event-search {
				width: 180px;
			}

			.account-search {
				width: 110px;

				.el-input__icon {
					font-size: 10px;
					width: 21px;
				}

				.el-input__inner {
					padding-right: 21px;
				}

				.el-button {
					padding: 8px 15px;
				}
			}

			.searchInput {
				width: 130px;
			}

			.date-picker {
				width: 130px;
			}
		}
	}
}

.ellipsis-mult {
	width: 100px;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
}

.trigger-strategy-text {
	width: 100%;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
}

.alarm-trigger-tooltip {
	max-width: 420px;
	padding: 12px 14px !important;
	color: #303133 !important;
	background: #fff !important;
	border: 1px solid #d9e2ec !important;
	border-radius: 6px !important;
	box-shadow: 0 6px 18px rgba(31, 45, 61, 0.14);
	line-height: 1.6 !important;
}

.alarm-trigger-tooltip-content {
	max-height: 280px;
	overflow-y: auto;
	white-space: pre-wrap;
	word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// alarm-notify.vue?76b0b3cc